/**
 * Google Analytics Event Names Enum
 * Defines all custom events tracked in the application
 */
export enum GoogleAnalyticsEvents {
  // Event Gallery Events
  VIEW_EVENT_GALLERY = 'view_event_gallery',

  // Photo Interaction Events
  PHOTO_CLICKED = 'photo_clicked',

  // Face Search Events
  FACE_SEARCH_USED = 'face_search_used',
  FACE_SEARCH_FAILED = 'face_search_failed',

  // Cart & Payment Events
  ADD_TO_CART = 'add_to_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
  VIEW_CART = 'view_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  PURCHASE_COMPLETED = 'purchase',

  // Download Events
  PHOTO_DOWNLOAD_STARTED = 'photo_download_started',
  PHOTO_DOWNLOAD_COMPLETED = 'photo_download_completed',

  FREE_PHOTO_DOWNLOADED = 'free_photo_downloaded',
  PAID_PHOTO_DOWNLOADED = 'paid_photo_downloaded',

  // User Engagement Events
  SEARCH_GALLERY = 'search_gallery',
  SHARE_EVENT = 'share_event',
  CONTACT_SUPPORT = 'contact_support',

  // Error Events
  IMAGE_LOAD_ERROR = 'image_load_error',
  API_ERROR = 'api_error',

  // Test Events (for development)
  TEST_EVENT = 'test_event',
}
